(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabecera-flotante"] && !Shopify.designMode) return;
  try {
    
(function () {
  var temporizador = null;

  function alternar(raiz, abrir) {
    var boton = raiz.querySelector('[data-cabecera-boton]');
    raiz.classList.toggle('cabecera--abierto', abrir);

    if (boton) {
      boton.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      boton.setAttribute('aria-label', boton.getAttribute(abrir ? 'data-texto-cerrar' : 'data-texto-abrir'));
    }
  }

  function iniciar(raiz) {
    var barra = raiz.querySelector('[data-cabecera-barra]');
    var espaciador = raiz.querySelector('[data-cabecera-espaciador]');
    var fijo = raiz.getAttribute('data-fijo') === 'true';
    var superpuesto = raiz.getAttribute('data-superpuesto') === 'true';
    var minimo = parseFloat(raiz.getAttribute('data-minimo')) || 0;
    var pendiente = false;

    if (!barra) {
      return;
    }

    function desconectar() {
      window.removeEventListener('resize', alCambiar);
      window.removeEventListener('load', alCambiar);
      window.removeEventListener('scroll', alDesplazar);
    }

    function medir() {
      var alto = barra.offsetHeight;
      if (espaciador) {
        espaciador.style.setProperty('height', alto + 'px', 'important');
      }
      document.documentElement.style.setProperty('--altura-encabezado', (superpuesto ? alto : 0) + 'px', 'important');
    }

    function posicionar() {
      pendiente = false;
      if (!raiz.isConnected) {
        desconectar();
        return;
      }
      if (fijo || superpuesto) {
        var natural = raiz.getBoundingClientRect().top;
        var arriba = fijo ? Math.max(minimo, natural) : natural + window.scrollY;
        barra.style.setProperty('top', arriba + 'px', 'important');
      }
      raiz.classList.add('cabecera--lista');
    }

    function alCambiar() {
      if (!raiz.isConnected) {
        desconectar();
        return;
      }
      medir();
      posicionar();
    }

    function alDesplazar() {
      if (!raiz.isConnected) {
        desconectar();
        return;
      }
      raiz.classList.toggle('cabecera--con-scroll', window.scrollY > 8);
      if (!pendiente) {
        pendiente = true;
        window.requestAnimationFrame(posicionar);
      }
    }

    alCambiar();
    window.addEventListener('resize', alCambiar);
    window.addEventListener('load', alCambiar);

    if ('ResizeObserver' in window) {
      var vigia = new ResizeObserver(alCambiar);
      vigia.observe(barra);
      vigia.observe(document.body);
    }

    if (fijo) {
      alDesplazar();
      window.addEventListener('scroll', alDesplazar, { passive: true });
    }
  }

  function pintarCantidad(cantidad) {
    document.querySelectorAll('[data-cabecera-contador]').forEach(function (contador) {
      contador.textContent = cantidad;
      contador.hidden = cantidad < 1;
    });
    document.querySelectorAll('[data-cabecera-lector]').forEach(function (lector) {
      lector.textContent = 'Carrito: ' + cantidad + (cantidad === 1 ? ' artículo' : ' artículos');
    });
  }

  function actualizarCarrito() {
    var raizRutas = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(raizRutas + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (respuesta) {
        return respuesta.json();
      })
      .then(function (carrito) {
        pintarCantidad(carrito.item_count);
      })
      .catch(function () {});
  }

  function programarActualizacion() {
    window.clearTimeout(temporizador);
    temporizador = window.setTimeout(actualizarCarrito, 150);
  }

  function iniciarTodas() {
    document.querySelectorAll('[data-cabecera]').forEach(function (raiz) {
      if (raiz.getAttribute('data-iniciado') === 'true') {
        return;
      }
      raiz.setAttribute('data-iniciado', 'true');
      iniciar(raiz);
    });
  }

  document.addEventListener('click', function (evento) {
    var boton = evento.target.closest('[data-cabecera-boton]');

    if (boton) {
      var raizBoton = boton.closest('[data-cabecera]');
      alternar(raizBoton, !raizBoton.classList.contains('cabecera--abierto'));
      return;
    }

    document.querySelectorAll('.cabecera--abierto').forEach(function (raiz) {
      var panel = raiz.querySelector('[data-cabecera-panel]');
      if (!panel || !panel.contains(evento.target) || evento.target.closest('a')) {
        alternar(raiz, false);
      }
    });
  });

  document.addEventListener('keydown', function (evento) {
    if (evento.key !== 'Escape') {
      return;
    }
    document.querySelectorAll('.cabecera--abierto').forEach(function (raiz) {
      alternar(raiz, false);
      var boton = raiz.querySelector('[data-cabecera-boton]');
      if (boton) {
        boton.focus();
      }
    });
  });

  if ('PerformanceObserver' in window) {
    try {
      var observador = new PerformanceObserver(function (lista) {
        lista.getEntries().forEach(function (entrada) {
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(entrada.name)) {
            programarActualizacion();
          }
        });
      });
      observador.observe({ type: 'resource', buffered: false });
    } catch (error) {}
  }

  window.addEventListener('pageshow', function (evento) {
    if (evento.persisted) {
      actualizarCarrito();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', iniciarTodas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrito-nuevo"] && !Shopify.designMode) return;
  try {
    
(function () {
  var memoria = { activador: null, propia: 0, aviso: null };

  function raiz() {
    return document.querySelector('[data-carrito-lateral]');
  }

  function rutaBase() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function contenido(r) {
    return r.querySelector('[data-cl-contenido]');
  }

  function estaAbierto(r) {
    return r.classList.contains('carrito-lateral--abierto');
  }

  function enfocables(r) {
    var panel = r.querySelector('[data-cl-panel]');
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0;
      }
    );
  }

  function abrir(origen) {
    var r = raiz();
    if (!r || estaAbierto(r)) {
      return;
    }
    memoria.activador = origen || document.activeElement;
    r.classList.add('carrito-lateral--abierto');
    r.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('carrito-lateral-bloqueado');
    window.setTimeout(function () {
      var botones = enfocables(r);
      var cerrar = r.querySelector('.carrito-lateral__cerrar');
      (cerrar || botones[0] || r.querySelector('[data-cl-panel]')).focus({ preventScroll: true });
    }, 80);
    document.dispatchEvent(new CustomEvent('carrito:abierto'));
  }

  function cerrar(devolverFoco) {
    var r = raiz();
    if (!r || !estaAbierto(r)) {
      return;
    }
    r.classList.remove('carrito-lateral--abierto');
    r.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('carrito-lateral-bloqueado');
    if (devolverFoco !== false && memoria.activador && document.contains(memoria.activador)) {
      memoria.activador.focus({ preventScroll: true });
    }
    document.dispatchEvent(new CustomEvent('carrito:cerrado'));
  }

  function avisar(mensaje) {
    var r = raiz();
    var aviso = r && r.querySelector('[data-cl-aviso]');
    if (!aviso) {
      return;
    }
    aviso.textContent = mensaje;
    aviso.hidden = false;
    window.clearTimeout(memoria.aviso);
    memoria.aviso = window.setTimeout(function () {
      aviso.hidden = true;
    }, 5000);
  }

  function pintar(html) {
    var r = raiz();
    if (!r || !html) {
      return;
    }
    var nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cl-contenido]');
    var actual = contenido(r);
    if (!nuevo || !actual) {
      return;
    }
    var cuerpo = actual.querySelector('[data-cl-cuerpo]');
    var desplazamiento = cuerpo ? cuerpo.scrollTop : 0;
    var barraAntes = actual.querySelector('.carrito-lateral__barra-caja');
    var progresoAntes = barraAntes ? barraAntes.style.getPropertyValue('--cl-progreso') : '0%';
    var detalleAntes = actual.querySelector('[data-cl-beneficios]');
    var detalleAbierto = detalleAntes ? detalleAntes.open : null;
    actual.innerHTML = nuevo.innerHTML;
    var barraNueva = actual.querySelector('.carrito-lateral__barra-caja');
    if (barraNueva) {
      var progresoNuevo = barraNueva.style.getPropertyValue('--cl-progreso');
      if (progresoAntes && progresoAntes !== progresoNuevo) {
        barraNueva.style.setProperty('--cl-progreso', progresoAntes);
        void barraNueva.offsetWidth;
        window.requestAnimationFrame(function () {
          barraNueva.style.setProperty('--cl-progreso', progresoNuevo);
        });
      }
    }
    var detalleNuevo = actual.querySelector('[data-cl-beneficios]');
    if (detalleNuevo && detalleAbierto !== null) {
      detalleNuevo.open = detalleAbierto;
    }
    var cuerpoNuevo = actual.querySelector('[data-cl-cuerpo]');
    if (cuerpoNuevo) {
      cuerpoNuevo.scrollTop = desplazamiento;
    }
    document.dispatchEvent(new CustomEvent('carrito:actualizado'));
  }

  function refrescar() {
    var r = raiz();
    if (!r) {
      return Promise.resolve();
    }
    var id = r.getAttribute('data-seccion-id');
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
      .then(function (respuesta) {
        return respuesta.json();
      })
      .then(function (datos) {
        pintar(datos[id]);
      })
      .catch(function () {});
  }

  function enviar(ruta, cuerpo, esFormulario) {
    var r = raiz();
    var id = r.getAttribute('data-seccion-id');
    var opciones = { method: 'POST', headers: { Accept: 'application/json' } };

    if (esFormulario) {
      cuerpo.append('sections', id);
      cuerpo.append('sections_url', window.location.pathname);
      opciones.body = cuerpo;
    } else {
      cuerpo.sections = id;
      cuerpo.sections_url = window.location.pathname;
      opciones.headers['Content-Type'] = 'application/json';
      opciones.body = JSON.stringify(cuerpo);
    }

    r.classList.add('carrito-lateral--cargando');
    memoria.propia = Date.now();

    return fetch(rutaBase() + ruta, opciones)
      .then(function (respuesta) {
        return respuesta.json().then(function (datos) {
          return { ok: respuesta.ok, datos: datos };
        });
      })
      .then(function (resultado) {
        if (!resultado.ok) {
          avisar(resultado.datos.description || resultado.datos.message || 'No se pudo actualizar el carrito.');
          return false;
        }
        if (resultado.datos.sections && resultado.datos.sections[id]) {
          pintar(resultado.datos.sections[id]);
        } else {
          return refrescar().then(function () {
            return true;
          });
        }
        return true;
      })
      .catch(function () {
        avisar('No pudimos conectar. Intenta de nuevo.');
        return false;
      })
      .then(function (ok) {
        r.classList.remove('carrito-lateral--cargando');
        memoria.propia = Date.now();
        return ok;
      });
  }

  function esEnlaceCarrito(enlace, evento) {
    var r = raiz();
    if (!r || r.getAttribute('data-en-pagina-carrito') === 'true') {
      return false;
    }
    if (evento.defaultPrevented || evento.button !== 0 || evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) {
      return false;
    }
    if (enlace.target && enlace.target !== '_self') {
      return false;
    }
    if (r.contains(enlace)) {
      return false;
    }
    var destino;
    try {
      destino = new URL(enlace.href, window.location.href);
    } catch (error) {
      return false;
    }
    var ruta = (r.getAttribute('data-ruta-carrito') || '/cart').replace(/\/$/, '');
    return destino.origin === window.location.origin && destino.pathname.replace(/\/$/, '') === ruta;
  }

  function manejarAccion(boton) {
    var accion = boton.getAttribute('data-cl-accion');
    var clave = boton.getAttribute('data-cl-clave');

    if (accion === 'cerrar') {
      cerrar();
      return;
    }
    if (accion === 'cantidad') {
      enviar('cart/change.js', { id: clave, quantity: parseInt(boton.getAttribute('data-cl-cantidad'), 10) });
      return;
    }
    if (accion === 'agregar') {
      var tarjeta = boton.closest('.carrito-lateral__sugerido');
      var selector = tarjeta && tarjeta.querySelector('[data-cl-selector]');
      var variante = selector ? selector.value : boton.getAttribute('data-cl-variante');
      enviar('cart/add.js', { items: [{ id: parseInt(variante, 10), quantity: 1 }] });
    }
  }

  document.addEventListener(
    'click',
    function (evento) {
      var r = raiz();
      if (!r) {
        return;
      }

      var boton = evento.target.closest('[data-cl-accion]');
      if (boton && r.contains(boton)) {
        if (boton.tagName === 'A' && boton.getAttribute('data-cl-accion') === 'cerrar') {
          cerrar(false);
          return;
        }
        evento.preventDefault();
        manejarAccion(boton);
        return;
      }

      var disparador = evento.target.closest('[data-abrir-carrito]');
      if (disparador) {
        evento.preventDefault();
        refrescar().then(function () {
          abrir(disparador);
        });
        return;
      }

      if (r.getAttribute('data-enlaces') === 'true') {
        var enlace = evento.target.closest('a[href]');
        if (enlace && esEnlaceCarrito(enlace, evento)) {
          evento.preventDefault();
          evento.stopPropagation();
          refrescar().then(function () {
            abrir(enlace);
          });
        }
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (evento) {
      var r = raiz();
      var formulario = evento.target;
      if (!r || r.getAttribute('data-formularios') !== 'true' || !formulario || !formulario.action) {
        return;
      }
      if (formulario.action.indexOf('/cart/add') === -1 || r.contains(formulario)) {
        return;
      }
      if (evento.submitter && evento.submitter.name === 'checkout') {
        return;
      }
      evento.preventDefault();
      evento.stopImmediatePropagation();
      enviar('cart/add.js', new FormData(formulario), true).then(function (ok) {
        if (ok && r.getAttribute('data-abrir-al-agregar') === 'true') {
          abrir(evento.submitter || document.activeElement);
        }
      });
    },
    true
  );

  document.addEventListener('change', function (evento) {
    var selector = evento.target.closest('[data-cl-selector]');
    if (!selector) {
      return;
    }
    var opcion = selector.options[selector.selectedIndex];
    var tarjeta = selector.closest('.carrito-lateral__sugerido');
    var precio = tarjeta && tarjeta.querySelector('[data-cl-precio]');
    var comparacion = tarjeta && tarjeta.querySelector('[data-cl-comparacion]');
    var ahorro = tarjeta && tarjeta.querySelector('[data-cl-ahorro]');
    if (ahorro && opcion) {
      var valorAhorro = opcion.getAttribute('data-ahorro');
      ahorro.textContent = valorAhorro ? ahorro.getAttribute('data-prefijo') + ' ' + valorAhorro : '';
      ahorro.hidden = !valorAhorro;
    }
    if (precio && opcion) {
      precio.textContent = opcion.getAttribute('data-precio');
    }
    if (comparacion && opcion) {
      var anterior = opcion.getAttribute('data-comparacion');
      comparacion.textContent = anterior || '';
      comparacion.hidden = !anterior;
    }
  });

  document.addEventListener('keydown', function (evento) {
    var r = raiz();
    if (!r || !estaAbierto(r)) {
      return;
    }
    if (evento.key === 'Escape') {
      cerrar();
      return;
    }
    if (evento.key === 'Tab') {
      var lista = enfocables(r);
      if (!lista.length) {
        return;
      }
      var primero = lista[0];
      var ultimo = lista[lista.length - 1];
      if (evento.shiftKey && document.activeElement === primero) {
        evento.preventDefault();
        ultimo.focus();
      } else if (!evento.shiftKey && document.activeElement === ultimo) {
        evento.preventDefault();
        primero.focus();
      }
    }
  });

  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (lista) {
        lista.getEntries().forEach(function (entrada) {
          var r = raiz();
          if (!r || Date.now() - memoria.propia < 1500) {
            return;
          }
          if (/\/cart\/add(\.js)?(\?|$)/.test(entrada.name)) {
            refrescar().then(function () {
              if (r.getAttribute('data-abrir-al-agregar') === 'true') {
                abrir();
              }
            });
          } else if (/\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(entrada.name)) {
            refrescar();
          }
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (error) {}
  }

  document.addEventListener('carrito:abrir', function () {
    refrescar().then(function () {
      abrir();
    });
  });

  document.addEventListener('shopify:section:select', function (evento) {
    var r = raiz();
    if (r && evento.detail && evento.detail.sectionId && r.getAttribute('data-seccion-id').indexOf(evento.detail.sectionId) !== -1) {
      abrir();
    }
  });

  document.addEventListener('shopify:section:deselect', function () {
    cerrar(false);
  });

  window.addEventListener('pageshow', function (evento) {
    if (evento.persisted) {
      refrescar();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clientes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function ajustar(seccion) {
    var pista = seccion.querySelector('[data-tm-pista]');
    var grupo = seccion.querySelector('[data-tm-grupo]');
    if (!pista || !grupo) {
      return;
    }
    var velocidad = parseFloat(seccion.getAttribute('data-velocidad')) || 50;
    var ancho = grupo.getBoundingClientRect().width;
    if (ancho > 0) {
      pista.style.setProperty('animation-duration', (ancho / velocidad).toFixed(2) + 's', 'important');
    }
  }

  function iniciar(contexto) {
    var secciones = (contexto || document).querySelectorAll('[data-testimonios-movil]');
    secciones.forEach(function (seccion) {
      ajustar(seccion);
      if (seccion.getAttribute('data-listo') === 'si') {
        return;
      }
      seccion.setAttribute('data-listo', 'si');
      if (window.ResizeObserver) {
        var grupo = seccion.querySelector('[data-tm-grupo]');
        if (grupo) {
          new ResizeObserver(function () {
            ajustar(seccion);
          }).observe(grupo);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciar();
    });
  } else {
    iniciar();
  }
  window.addEventListener('load', function () {
    iniciar();
  });
  document.addEventListener('shopify:section:load', function (evento) {
    iniciar(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compra-producto"] && !Shopify.designMode) return;
  try {
    
(function () {
  function escalar(texto, factor) {
    var m = String(texto).match(/^(\D*?)(\d[\d.,\s  ']*\d|\d)(\D*)$/);
    if (!m) return texto;
    var num = m[2];
    var dec = num.match(/[.,](\d{2})$/);
    var ent = num;
    var decimales = '';
    var sepDec = '';
    if (dec) {
      decimales = dec[1];
      sepDec = num.charAt(num.length - 3);
      ent = num.slice(0, num.length - 3);
    }
    var sepMiles = ent.match(/[^\d]/);
    sepMiles = sepMiles ? sepMiles[0] : '';
    var valor = parseInt(ent.replace(/\D/g, ''), 10) * 100 + (decimales ? parseInt(decimales, 10) : 0);
    valor = Math.round(valor * factor);
    var enteros = String(decimales ? Math.floor(valor / 100) : Math.round(valor / 100));
    if (sepMiles) enteros = enteros.replace(/\B(?=(\d{3})+(?!\d))/g, sepMiles);
    var resultado = enteros;
    if (decimales) resultado += sepDec + ('0' + (valor % 100)).slice(-2);
    return m[1] + resultado + m[3];
  }

  function iniciarResenas(seccion) {
    var contenedor = seccion.querySelector('[data-cp-resenas]');
    if (!contenedor) return;
    var pista = contenedor.querySelector('[data-cp-resenas-pista]');
    var puntosCaja = contenedor.querySelector('[data-cp-resenas-puntos]');
    var tarjetas = pista ? pista.children : [];
    var total = tarjetas.length;
    if (!pista || total < 2) return;

    var auto = seccion.getAttribute('data-resenas-auto') === 'true';
    var segundos = parseFloat(seccion.getAttribute('data-resenas-segundos')) || 5;
    var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var actual = 0;
    var reloj = null;
    var pausado = false;
    var visible = true;
    var cuadro = null;
    var puntos = [];

    if (puntosCaja) {
      for (var n = 0; n < total; n++) {
        var punto = document.createElement('button');
        punto.type = 'button';
        punto.className = 'compra-producto__punto-resena';
        punto.setAttribute('aria-label', 'Ver opinión ' + (n + 1));
        punto.setAttribute('aria-current', n === 0 ? 'true' : 'false');
        (function (i) {
          punto.addEventListener('click', function () { ir(i, true); });
        })(n);
        puntosCaja.appendChild(punto);
        puntos.push(punto);
      }
      puntosCaja.hidden = false;
    }

    function marcar(i) {
      actual = i;
      puntos.forEach(function (p, k) { p.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }

    function ir(i, manual) {
      i = (i + total) % total;
      var destino = tarjetas[i].offsetLeft;
      pista.scrollTo({ left: destino, behavior: reducido ? 'auto' : 'smooth' });
      marcar(i);
      if (manual) reiniciar();
    }

    function detener() {
      if (reloj) { window.clearInterval(reloj); reloj = null; }
    }

    function iniciarReloj() {
      detener();
      if (!auto || reducido || pausado || !visible) return;
      reloj = window.setInterval(function () { ir(actual + 1, false); }, segundos * 1000);
    }

    function reiniciar() { iniciarReloj(); }

    pista.addEventListener('scroll', function () {
      if (cuadro) return;
      cuadro = window.requestAnimationFrame(function () {
        cuadro = null;
        var base = pista.scrollLeft;
        var mejor = 0;
        var distancia = Infinity;
        for (var k = 0; k < total; k++) {
          var d = Math.abs(tarjetas[k].offsetLeft - base);
          if (d < distancia) { distancia = d; mejor = k; }
        }
        if (mejor !== actual) marcar(mejor);
      });
    }, { passive: true });

    contenedor.addEventListener('mouseenter', function () { pausado = true; detener(); });
    contenedor.addEventListener('mouseleave', function () { pausado = false; iniciarReloj(); });
    contenedor.addEventListener('focusin', function () { pausado = true; detener(); });
    contenedor.addEventListener('focusout', function () { pausado = false; iniciarReloj(); });
    pista.addEventListener('touchstart', function () { pausado = true; detener(); }, { passive: true });
    pista.addEventListener('touchend', function () {
      window.setTimeout(function () { pausado = false; iniciarReloj(); }, 1200);
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        visible = entradas[0].isIntersecting;
        if (visible) iniciarReloj(); else detener();
      }, { threshold: 0.2 }).observe(contenedor);
    }

    iniciarReloj();
  }

  function iniciar(seccion) {
    if (!seccion || seccion.getAttribute('data-cp-listo') === 'true') return;
    seccion.setAttribute('data-cp-listo', 'true');
    iniciarResenas(seccion);

    var datosNodo = seccion.querySelector('[data-cp-datos]');
    var formulario = seccion.querySelector('[data-cp-formulario]');
    if (!datosNodo || !formulario) return;

    var datos;
    try { datos = JSON.parse(datosNodo.textContent); } catch (e) { return; }

    var variantes = datos.variantes || [];
    var pista = seccion.querySelector('[data-cp-pista]');
    var laminas = seccion.querySelectorAll('[data-cp-lamina]');
    var carrusel = seccion.querySelector('[data-cp-miniaturas]');
    var miniaturas = seccion.querySelectorAll('[data-cp-miniatura]');
    var flechaAnterior = seccion.querySelector('[data-cp-anterior]');
    var flechaSiguiente = seccion.querySelector('[data-cp-siguiente]');
    var miniAnterior = seccion.querySelector('[data-cp-mini-anterior]');
    var miniSiguiente = seccion.querySelector('[data-cp-mini-siguiente]');
    var campoId = formulario.querySelector('[data-cp-id]');
    var campoCantidad = formulario.querySelector('[data-cp-cantidad-campo]');
    var boton = formulario.querySelector('[data-cp-boton]');
    var botonTexto = formulario.querySelector('[data-cp-boton-texto]');
    var botonPrecio = formulario.querySelector('[data-cp-boton-precio]');
    var precio = formulario.querySelector('[data-cp-precio]');
    var comparar = formulario.querySelector('[data-cp-comparar]');
    var porcion = formulario.querySelector('[data-cp-porcion]');
    var mensaje = formulario.querySelector('[data-cp-mensaje]');
    var grupos = formulario.querySelectorAll('[data-cp-grupo]');
    var paquetes = formulario.querySelectorAll('[data-cp-paquete]');
    var actual = null;
    var indice = 0;
    var temporizador = null;
    var cuadro = null;

    variantes.forEach(function (v) { if (v.id === datos.inicial) actual = v; });
    if (!actual && variantes.length) actual = variantes[0];

    function reducido() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function paqueteElegido() {
      var elegido = null;
      paquetes.forEach(function (p) { if (p.checked) elegido = p; });
      return elegido;
    }

    function cantidad() {
      var p = paqueteElegido();
      var n = p ? parseInt(p.getAttribute('data-cantidad'), 10) : 1;
      return n && n > 0 ? n : 1;
    }

    function factorTotal(p) {
      if (!p || !actual) return 1;
      var q = parseInt(p.getAttribute('data-cantidad'), 10) || 1;
      if (p.getAttribute('data-tipo') === 'fijo') {
        var fijo = parseFloat(p.getAttribute('data-fijo')) || 0;
        var centavos = actual.centavos || 0;
        if (fijo > 0 && centavos > 0) return Math.max(0, (q * centavos - fijo * 100) / centavos);
        return q;
      }
      var d = parseFloat(p.getAttribute('data-descuento')) || 0;
      return q * (1 - d / 100);
    }

    function pintarPaquetes() {
      if (!actual) return;
      paquetes.forEach(function (p) {
        var etiqueta = p.closest('.compra-producto__paquete');
        var q = parseInt(p.getAttribute('data-cantidad'), 10) || 1;
        var factor = factorTotal(p);
        var conDescuento = factor < q - 0.00001;
        var total = etiqueta.querySelector('[data-cp-p-total]');
        var original = etiqueta.querySelector('[data-cp-p-original]');
        var ahorro = etiqueta.querySelector('[data-cp-p-ahorro]');
        var chip = etiqueta.querySelector('[data-cp-p-porcion]');
        if (total) total.textContent = escalar(actual.precio, factor);
        if (original) {
          var texto = '';
          if (conDescuento) texto = escalar(actual.precio, q);
          else if (actual.comparar) texto = escalar(actual.comparar, q);
          original.textContent = texto;
          original.hidden = !texto;
        }
        if (ahorro) {
          ahorro.hidden = !conDescuento;
          if (conDescuento) ahorro.textContent = ahorro.getAttribute('data-prefijo') + ' ' + escalar(actual.precio, q - factor);
        }
        if (chip && datos.porciones > 0) {
          chip.textContent = escalar(actual.precio, factor / q / datos.porciones) + (datos.textoPorcion || '');
        }
        etiqueta.classList.toggle('compra-producto__paquete--activo', p.checked);
      });
      if (campoCantidad) campoCantidad.value = cantidad();
    }

    function pintarBoton() {
      if (!actual) return;
      if (actual.disponible) {
        boton.disabled = false;
        botonTexto.textContent = boton.getAttribute('data-texto');
        if (botonPrecio) {
          botonPrecio.hidden = false;
          botonPrecio.textContent = '· ' + escalar(actual.precio, paqueteElegido() ? factorTotal(paqueteElegido()) : 1);
        }
      } else {
        boton.disabled = true;
        botonTexto.textContent = boton.getAttribute('data-agotado');
        if (botonPrecio) botonPrecio.hidden = true;
      }
    }

    function actualizarFlechasMini() {
      if (!carrusel || !miniAnterior || !miniSiguiente) return;
      var maximo = carrusel.scrollWidth - carrusel.clientWidth;
      var hayDesborde = maximo > 2;
      miniAnterior.hidden = !hayDesborde || carrusel.scrollLeft <= 2;
      miniSiguiente.hidden = !hayDesborde || carrusel.scrollLeft >= maximo - 2;
    }

    function marcarMiniatura(i) {
      indice = i;
      miniaturas.forEach(function (m, n) {
        m.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      if (carrusel && miniaturas[i]) {
        var destino = miniaturas[i].offsetLeft - (carrusel.clientWidth - miniaturas[i].clientWidth) / 2;
        carrusel.scrollTo({ left: Math.max(0, destino), behavior: reducido() ? 'auto' : 'smooth' });
      }
      if (flechaAnterior) flechaAnterior.disabled = i <= 0;
      if (flechaSiguiente) flechaSiguiente.disabled = i >= laminas.length - 1;
    }

    function irALamina(i) {
      if (!pista || !laminas[i]) return;
      pista.scrollTo({ left: laminas[i].offsetLeft - pista.offsetLeft, behavior: reducido() ? 'auto' : 'smooth' });
      marcarMiniatura(i);
    }

    function pintarVariante() {
      if (!actual) return;
      campoId.value = actual.id;
      if (precio) precio.textContent = actual.precio;
      if (comparar) {
        comparar.hidden = !actual.comparar;
        comparar.textContent = actual.comparar || '';
      }
      if (porcion && actual.porcion) porcion.textContent = actual.porcion + (datos.textoPorcion || '');
      pintarPaquetes();
      pintarBoton();
    }

    function marcarAgotados() {
      var elegidas = [];
      grupos.forEach(function (g) {
        var r = g.querySelector('[data-cp-opcion]:checked');
        elegidas.push(r ? r.value : null);
      });
      grupos.forEach(function (g, posicion) {
        g.querySelectorAll('[data-cp-opcion]').forEach(function (r) {
          var hay = variantes.some(function (v) {
            if (!v.disponible || v.opciones[posicion] !== r.value) return false;
            return v.opciones.every(function (o, i) { return i === posicion || elegidas[i] === null || elegidas[i] === o; });
          });
          r.closest('.compra-producto__valor').classList.toggle('compra-producto__valor--agotado', !hay);
        });
      });
    }

    function alElegir() {
      var elegidas = [];
      grupos.forEach(function (g) {
        var r = g.querySelector('[data-cp-opcion]:checked');
        elegidas.push(r ? r.value : null);
      });
      var encontrada = null;
      variantes.forEach(function (v) {
        if (v.opciones.every(function (o, i) { return o === elegidas[i]; })) encontrada = v;
      });
      actual = encontrada;
      if (!actual) {
        boton.disabled = true;
        botonTexto.textContent = boton.getAttribute('data-agotado');
        if (botonPrecio) botonPrecio.hidden = true;
        marcarAgotados();
        return;
      }
      pintarVariante();
      marcarAgotados();
      if (actual.medio) {
        laminas.forEach(function (l, i) {
          if (String(l.getAttribute('data-medio')) === String(actual.medio)) irALamina(i);
        });
      }
    }

    formulario.querySelectorAll('[data-cp-opcion]').forEach(function (r) {
      r.addEventListener('change', alElegir);
    });

    paquetes.forEach(function (p) {
      p.addEventListener('change', function () {
        pintarPaquetes();
        pintarBoton();
      });
    });

    miniaturas.forEach(function (m) {
      m.addEventListener('click', function () {
        irALamina(parseInt(m.getAttribute('data-indice'), 10));
      });
    });

    if (flechaAnterior) flechaAnterior.addEventListener('click', function () { irALamina(Math.max(0, indice - 1)); });
    if (flechaSiguiente) flechaSiguiente.addEventListener('click', function () { irALamina(Math.min(laminas.length - 1, indice + 1)); });

    if (miniAnterior) miniAnterior.addEventListener('click', function () {
      carrusel.scrollBy({ left: -carrusel.clientWidth * 0.8, behavior: reducido() ? 'auto' : 'smooth' });
    });
    if (miniSiguiente) miniSiguiente.addEventListener('click', function () {
      carrusel.scrollBy({ left: carrusel.clientWidth * 0.8, behavior: reducido() ? 'auto' : 'smooth' });
    });
    if (carrusel) {
      carrusel.addEventListener('scroll', actualizarFlechasMini, { passive: true });
      window.addEventListener('resize', actualizarFlechasMini);
    }

    if (pista && laminas.length > 1) {
      pista.addEventListener('scroll', function () {
        if (cuadro) return;
        cuadro = window.requestAnimationFrame(function () {
          cuadro = null;
          var ancho = pista.clientWidth || 1;
          var nuevo = Math.round(pista.scrollLeft / ancho);
          if (nuevo !== indice) marcarMiniatura(nuevo);
        });
      }, { passive: true });
    }

    function mostrarMensaje(texto) {
      if (!mensaje) return;
      mensaje.textContent = texto || '';
      mensaje.hidden = !texto;
    }

    formulario.addEventListener('submit', function (evento) {
      evento.preventDefault();
      if (!actual || !actual.disponible || boton.getAttribute('aria-busy') === 'true') return;
      mostrarMensaje('');
      boton.setAttribute('aria-busy', 'true');
      var cuerpo = JSON.stringify({ items: [{ id: actual.id, quantity: cantidad() }] });
      fetch(seccion.getAttribute('data-url-agregar'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: cuerpo
      })
        .then(function (respuesta) {
          return respuesta.json().then(function (json) { return { ok: respuesta.ok, json: json }; });
        })
        .then(function (resultado) {
          boton.removeAttribute('aria-busy');
          if (!resultado.ok) {
            mostrarMensaje(resultado.json && (resultado.json.description || resultado.json.message) || 'No pudimos añadir el producto. Intenta de nuevo.');
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: resultado.json }));
          var accion = seccion.getAttribute('data-accion');
          if (accion === 'carrito') {
            window.location.href = seccion.getAttribute('data-url-carrito');
            return;
          }
          if (accion === 'abrir') {
            var selector = seccion.getAttribute('data-selector-carrito');
            var disparador = null;
            if (selector) {
              try { disparador = document.querySelector(selector); } catch (e) { disparador = null; }
            }
            if (disparador) {
              disparador.click();
            } else {
              window.location.href = seccion.getAttribute('data-url-carrito');
              return;
            }
          }
          botonTexto.textContent = boton.getAttribute('data-agregado');
          window.clearTimeout(temporizador);
          temporizador = window.setTimeout(pintarBoton, 2200);
        })
        .catch(function () {
          boton.removeAttribute('aria-busy');
          mostrarMensaje('No pudimos añadir el producto. Revisa tu conexión e intenta de nuevo.');
        });
    });

    marcarAgotados();
    pintarVariante();
    marcarMiniatura(0);
    actualizarFlechasMini();
    window.setTimeout(actualizarFlechasMini, 400);
  }

  function iniciarTodas() {
    document.querySelectorAll('[data-compra-producto]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }
  document.addEventListener('shopify:section:load', function (evento) {
    var nodo = evento.target && evento.target.querySelector ? evento.target.querySelector('[data-compra-producto]') : null;
    if (nodo) iniciar(nodo);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-nuevo"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.faqSeccionListo) return;
  window.faqSeccionListo = true;

  document.addEventListener('click', function (evento) {
    var boton = evento.target.closest('[data-faq-boton]');
    if (!boton) return;
    var item = boton.closest('[data-faq-item]');
    var seccion = boton.closest('[data-faq-seccion]');
    if (!item || !seccion) return;
    var abrir = !item.classList.contains('faq-seccion__item--abierta');
    if (abrir && seccion.getAttribute('data-exclusivo') === 'true') {
      seccion.querySelectorAll('[data-faq-item].faq-seccion__item--abierta').forEach(function (otro) {
        otro.classList.remove('faq-seccion__item--abierta');
        var otroBoton = otro.querySelector('[data-faq-boton]');
        if (otroBoton) otroBoton.setAttribute('aria-expanded', 'false');
      });
    }
    item.classList.toggle('faq-seccion__item--abierta', abrir);
    boton.setAttribute('aria-expanded', abrir ? 'true' : 'false');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-nuevo"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__piePaisajeAcordeon) return;
  window.__piePaisajeAcordeon = true;

  var consulta = window.matchMedia('(max-width: 749px)');

  function marcarListos() {
    document.querySelectorAll('[data-pie-paisaje]').forEach(function (pie) {
      pie.classList.add('pie-paisaje--js');
    });
  }

  function alternar(columna, abrir) {
    var boton = columna.querySelector('[data-pie-disparador]');
    if (abrir) columna.setAttribute('data-abierta', '');
    else columna.removeAttribute('data-abierta');
    if (boton) boton.setAttribute('aria-expanded', abrir ? 'true' : 'false');
  }

  document.addEventListener('click', function (evento) {
    var boton = evento.target.closest ? evento.target.closest('[data-pie-disparador]') : null;
    if (!boton || !consulta.matches) return;
    var pie = boton.closest('[data-pie-paisaje]');
    var columna = boton.closest('[data-pie-columna]');
    if (!pie || !columna || !pie.classList.contains('pie-paisaje--acordeon')) return;
    var abrir = !columna.hasAttribute('data-abierta');
    if (abrir && pie.getAttribute('data-pie-uno') === 'true') {
      pie.querySelectorAll('[data-pie-columna][data-abierta]').forEach(function (otra) {
        if (otra !== columna) alternar(otra, false);
      });
    }
    alternar(columna, abrir);
  });

  function sincronizarAria() {
    document.querySelectorAll('[data-pie-columna]').forEach(function (columna) {
      var boton = columna.querySelector('[data-pie-disparador]');
      if (boton) boton.setAttribute('aria-expanded', columna.hasAttribute('data-abierta') ? 'true' : 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { marcarListos(); sincronizarAria(); });
  } else {
    marcarListos();
    sincronizarAria();
  }

  document.addEventListener('shopify:section:load', function () { marcarListos(); sincronizarAria(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formulario-pqrs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(panel) {
    if (panel.getAttribute('data-listo')) return;
    var form = panel.querySelector('form');
    if (!form) return;
    var pasos = Array.prototype.slice.call(form.querySelectorAll('[data-paso]'));
    if (!pasos.length) return;
    panel.setAttribute('data-listo', '1');
    var seccion = panel.closest('.pqrs-form');
    var total = pasos.length;
    var actual = 0;
    var cuenta = form.querySelector('[data-cuenta]');
    var relleno = form.querySelector('[data-relleno]');
    var atras = form.querySelector('[data-atras]');
    var resumen = form.querySelector('[data-resumen]');
    var de = panel.getAttribute('data-de') || 'de';
    var registrarIp = panel.getAttribute('data-registrar-ip') === 'true';
    var autorizacion = form.querySelector('[data-autorizacion]');
    var campoIp = form.querySelector('[data-ip]');
    var campoFecha = form.querySelector('[data-fecha]');
    var campoHora = form.querySelector('[data-hora]');

    seccion.classList.add('pqrs-form--js');

    function construirResumen() {
      if (!resumen) return;
      resumen.innerHTML = '';
      var textoCambiar = resumen.getAttribute('data-cambiar') || 'Cambiar';
      pasos.forEach(function (paso, indice) {
        if (paso.hasAttribute('data-revision')) return;
        var campos = paso.querySelectorAll('[data-res]');
        var vistos = {};
        Array.prototype.forEach.call(campos, function (campo) {
          var valor = '';
          if (campo.type === 'radio') {
            if (vistos[campo.name]) return;
            vistos[campo.name] = true;
            var marcado = paso.querySelector('input[name="' + campo.name.replace(/"/g, '\\"') + '"]:checked');
            valor = marcado ? marcado.value : '';
          } else {
            valor = (campo.value || '').trim();
            if (campo.hasAttribute('data-telefono')) {
              var ind = form.querySelector('[data-indicativo]');
              valor = ((ind ? ind.value : '') + ' ' + valor).trim();
            }
          }
          var fila = document.createElement('div');
          fila.className = 'pqrs-form__fila-resumen';
          var dt = document.createElement('dt');
          dt.className = 'pqrs-form__resumen-etiqueta';
          dt.textContent = campo.getAttribute('data-etiqueta') || '';
          var dd = document.createElement('dd');
          dd.className = 'pqrs-form__resumen-valor';
          dd.textContent = valor;
          var boton = document.createElement('button');
          boton.type = 'button';
          boton.className = 'pqrs-form__cambiar';
          boton.textContent = textoCambiar;
          boton.addEventListener('click', function () { ir(indice, true); });
          fila.appendChild(dt);
          fila.appendChild(dd);
          fila.appendChild(boton);
          resumen.appendChild(fila);
        });
      });
    }

    function ir(indice, enfocar) {
      actual = Math.max(0, Math.min(total - 1, indice));
      pasos.forEach(function (paso, i) {
        paso.classList.toggle('pqrs-form__paso--activo', i === actual);
      });
      seccion.classList.toggle('pqrs-form--ultimo', actual === total - 1);
      if (cuenta) cuenta.textContent = (actual + 1) + ' ' + de + ' ' + total;
      if (relleno) relleno.style.setProperty('--pq-avance', (((actual + 1) / total) * 100) + '%');
      if (atras) atras.hidden = actual === 0;
      if (actual === total - 1) construirResumen();
      if (enfocar) {
        var primero = pasos[actual].querySelector('input:not([type=hidden]), select, textarea');
        if (primero) primero.focus({ preventScroll: true });
        var tope = panel.getBoundingClientRect().top;
        if (tope < 0) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function valido() {
      var campos = pasos[actual].querySelectorAll('input, select, textarea');
      for (var i = 0; i < campos.length; i++) {
        if (!campos[i].disabled && !campos[i].reportValidity()) return false;
      }
      return true;
    }

    function siguiente() {
      if (actual < total - 1 && valido()) ir(actual + 1, true);
    }

    form.querySelector('[data-seguir]').addEventListener('click', siguiente);
    if (atras) atras.addEventListener('click', function () { ir(actual - 1, true); });

    form.addEventListener('keydown', function (evento) {
      if (evento.key === 'Enter' && evento.target.tagName !== 'TEXTAREA' && evento.target.tagName !== 'BUTTON' && actual < total - 1) {
        evento.preventDefault();
        siguiente();
      }
    });

    if (autorizacion && registrarIp && campoIp) {
      autorizacion.addEventListener('change', function () {
        if (!autorizacion.checked || campoIp.value) return;
        try {
          fetch('https://api.ipify.org?format=json')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (d && d.ip) { campoIp.value = d.ip; campoIp.disabled = false; }
            })
            .catch(function () {});
        } catch (e) {}
      });
    }

    form.addEventListener('submit', function () {
      var ahora = new Date();
      var dos = function (n) { return (n < 10 ? '0' : '') + n; };
      if (campoFecha) campoFecha.value = dos(ahora.getDate()) + '/' + dos(ahora.getMonth() + 1) + '/' + ahora.getFullYear();
      if (campoHora) campoHora.value = dos(ahora.getHours()) + ':' + dos(ahora.getMinutes());
    });

    ir(0, false);
  }

  function todos() {
    document.querySelectorAll('[data-pqrs]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todos);
  } else {
    todos();
  }
  document.addEventListener('shopify:section:load', todos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["garantia"] && !Shopify.designMode) return;
  try {
    
(function () {
  function idActual(formulario) {
    var porDefecto = formulario.querySelector('[data-gc-id]');
    var desdeUrl = null;
    try {
      desdeUrl = new URLSearchParams(window.location.search).get('variant');
    } catch (e) {
      desdeUrl = null;
    }
    if (desdeUrl) {
      return desdeUrl;
    }
    var formularios = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < formularios.length; i++) {
      if (formularios[i] === formulario) {
        continue;
      }
      var campo = formularios[i].querySelector('[name="id"]');
      if (campo && campo.value) {
        return campo.value;
      }
    }
    return porDefecto ? porDefecto.value : null;
  }

  function iniciar(contexto) {
    (contexto || document).querySelectorAll('[data-gc-formulario]').forEach(function (formulario) {
      if (formulario.getAttribute('data-listo') === 'si') {
        return;
      }
      formulario.setAttribute('data-listo', 'si');
      formulario.addEventListener('submit', function () {
        var campo = formulario.querySelector('[data-gc-id]');
        var id = idActual(formulario);
        if (campo && id) {
          campo.value = id;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciar();
    });
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', function (evento) {
    iniciar(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-home-productos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarSeccion(seccion) {
    var radios = seccion.querySelectorAll('.inicio-formulas__radio');
    var boton = seccion.querySelector('[data-inicio-formulas-boton]');

    if (!radios.length || !boton) {
      return;
    }

    var enlaceBase = boton.getAttribute('data-enlace-base') || boton.getAttribute('href') || '#';

    function actualizar() {
      radios.forEach(function (radio) {
        var tarjeta = radio.closest('.inicio-formulas__formula');

        if (tarjeta) {
          tarjeta.classList.toggle('inicio-formulas__formula--seleccionada', radio.checked);
        }

        if (radio.checked) {
          boton.setAttribute('href', radio.getAttribute('data-enlace') || enlaceBase);
        }
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', actualizar);
    });
  }

  function iniciarTodas() {
    document.querySelectorAll('[data-inicio-formulas]').forEach(function (seccion) {
      if (seccion.getAttribute('data-iniciado') === 'true') {
        return;
      }
      seccion.setAttribute('data-iniciado', 'true');
      iniciarSeccion(seccion);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', iniciarTodas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-productpage"] && !Shopify.designMode) return;
  try {
    
(function () {
  function escalar(texto, factor) {
    var m = String(texto).match(/^(\D*?)(\d[\d.,\s  ']*\d|\d)(\D*)$/);
    if (!m) return texto;
    var num = m[2];
    var dec = num.match(/[.,](\d{2})$/);
    var ent = num;
    var decimales = '';
    var sepDec = '';
    if (dec) {
      decimales = dec[1];
      sepDec = num.charAt(num.length - 3);
      ent = num.slice(0, num.length - 3);
    }
    var sepMiles = ent.match(/[^\d]/);
    sepMiles = sepMiles ? sepMiles[0] : '';
    var valor = parseInt(ent.replace(/\D/g, ''), 10) * 100 + (decimales ? parseInt(decimales, 10) : 0);
    valor = Math.round(valor * factor);
    var enteros = String(decimales ? Math.floor(valor / 100) : Math.round(valor / 100));
    if (sepMiles) enteros = enteros.replace(/\B(?=(\d{3})+(?!\d))/g, sepMiles);
    var resultado = enteros;
    if (decimales) resultado += sepDec + ('0' + (valor % 100)).slice(-2);
    return m[1] + resultado + m[3];
  }

  function iniciarResenas(seccion) {
    var contenedor = seccion.querySelector('[data-cp-resenas]');
    if (!contenedor) return;
    var pista = contenedor.querySelector('[data-cp-resenas-pista]');
    var puntosCaja = contenedor.querySelector('[data-cp-resenas-puntos]');
    var tarjetas = pista ? pista.children : [];
    var total = tarjetas.length;
    if (!pista || total < 2) return;

    var auto = seccion.getAttribute('data-resenas-auto') === 'true';
    var segundos = parseFloat(seccion.getAttribute('data-resenas-segundos')) || 5;
    var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var actual = 0;
    var reloj = null;
    var pausado = false;
    var visible = true;
    var cuadro = null;
    var puntos = [];

    if (puntosCaja) {
      for (var n = 0; n < total; n++) {
        var punto = document.createElement('button');
        punto.type = 'button';
        punto.className = 'hero-producto__punto-resena';
        punto.setAttribute('aria-label', 'Ver opinión ' + (n + 1));
        punto.setAttribute('aria-current', n === 0 ? 'true' : 'false');
        (function (i) {
          punto.addEventListener('click', function () { ir(i, true); });
        })(n);
        puntosCaja.appendChild(punto);
        puntos.push(punto);
      }
      puntosCaja.hidden = false;
    }

    function marcar(i) {
      actual = i;
      puntos.forEach(function (p, k) { p.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }

    function ir(i, manual) {
      i = (i + total) % total;
      var destino = tarjetas[i].offsetLeft;
      pista.scrollTo({ left: destino, behavior: reducido ? 'auto' : 'smooth' });
      marcar(i);
      if (manual) reiniciar();
    }

    function detener() {
      if (reloj) { window.clearInterval(reloj); reloj = null; }
    }

    function iniciarReloj() {
      detener();
      if (!auto || reducido || pausado || !visible) return;
      reloj = window.setInterval(function () { ir(actual + 1, false); }, segundos * 1000);
    }

    function reiniciar() { iniciarReloj(); }

    pista.addEventListener('scroll', function () {
      if (cuadro) return;
      cuadro = window.requestAnimationFrame(function () {
        cuadro = null;
        var base = pista.scrollLeft;
        var mejor = 0;
        var distancia = Infinity;
        for (var k = 0; k < total; k++) {
          var d = Math.abs(tarjetas[k].offsetLeft - base);
          if (d < distancia) { distancia = d; mejor = k; }
        }
        if (mejor !== actual) marcar(mejor);
      });
    }, { passive: true });

    contenedor.addEventListener('mouseenter', function () { pausado = true; detener(); });
    contenedor.addEventListener('mouseleave', function () { pausado = false; iniciarReloj(); });
    contenedor.addEventListener('focusin', function () { pausado = true; detener(); });
    contenedor.addEventListener('focusout', function () { pausado = false; iniciarReloj(); });
    pista.addEventListener('touchstart', function () { pausado = true; detener(); }, { passive: true });
    pista.addEventListener('touchend', function () {
      window.setTimeout(function () { pausado = false; iniciarReloj(); }, 1200);
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        visible = entradas[0].isIntersecting;
        if (visible) iniciarReloj(); else detener();
      }, { threshold: 0.2 }).observe(contenedor);
    }

    iniciarReloj();
  }

  function iniciar(seccion) {
    if (!seccion || seccion.getAttribute('data-cp-listo') === 'true') return;
    seccion.setAttribute('data-cp-listo', 'true');
    iniciarResenas(seccion);

    var datosNodo = seccion.querySelector('[data-cp-datos]');
    var formulario = seccion.querySelector('[data-cp-formulario]');
    if (!datosNodo || !formulario) return;

    var datos;
    try { datos = JSON.parse(datosNodo.textContent); } catch (e) { return; }

    var variantes = datos.variantes || [];
    var pista = seccion.querySelector('[data-cp-pista]');
    var laminas = seccion.querySelectorAll('[data-cp-lamina]');
    var carrusel = seccion.querySelector('[data-cp-miniaturas]');
    var miniaturas = seccion.querySelectorAll('[data-cp-miniatura]');
    var flechaAnterior = seccion.querySelector('[data-cp-anterior]');
    var flechaSiguiente = seccion.querySelector('[data-cp-siguiente]');
    var miniAnterior = seccion.querySelector('[data-cp-mini-anterior]');
    var miniSiguiente = seccion.querySelector('[data-cp-mini-siguiente]');
    var campoId = formulario.querySelector('[data-cp-id]');
    var campoCantidad = formulario.querySelector('[data-cp-cantidad-campo]');
    var boton = formulario.querySelector('[data-cp-boton]');
    var botonTexto = formulario.querySelector('[data-cp-boton-texto]');
    var botonPrecio = formulario.querySelector('[data-cp-boton-precio]');
    var hPrecio = seccion.querySelector('[data-cp-h-precio]');
    var hOriginal = seccion.querySelector('[data-cp-h-original]');
    var hOff = seccion.querySelector('[data-cp-h-off]');
    var precio = formulario.querySelector('[data-cp-precio]');
    var comparar = formulario.querySelector('[data-cp-comparar]');
    var porcion = formulario.querySelector('[data-cp-porcion]');
    var mensaje = formulario.querySelector('[data-cp-mensaje]');
    var grupos = formulario.querySelectorAll('[data-cp-grupo]');
    var paquetes = formulario.querySelectorAll('[data-cp-paquete]');
    var actual = null;
    var indice = 0;
    var temporizador = null;
    var cuadro = null;

    variantes.forEach(function (v) { if (v.id === datos.inicial) actual = v; });
    if (!actual && variantes.length) actual = variantes[0];

    function reducido() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function paqueteElegido() {
      var elegido = null;
      paquetes.forEach(function (p) { if (p.checked) elegido = p; });
      return elegido;
    }

    function cantidad() {
      var p = paqueteElegido();
      var n = p ? parseInt(p.getAttribute('data-cantidad'), 10) : 1;
      return n && n > 0 ? n : 1;
    }

    function factorTotal(p) {
      if (!p || !actual) return 1;
      var q = parseInt(p.getAttribute('data-cantidad'), 10) || 1;
      if (p.getAttribute('data-tipo') === 'fijo') {
        var fijo = parseFloat(p.getAttribute('data-fijo')) || 0;
        var centavos = actual.centavos || 0;
        if (fijo > 0 && centavos > 0) return Math.max(0, (q * centavos - fijo * 100) / centavos);
        return q;
      }
      var d = parseFloat(p.getAttribute('data-descuento')) || 0;
      return q * (1 - d / 100);
    }

    function pintarCabecera() {
      if (!actual || !hPrecio) return;
      var p = paqueteElegido();
      var q = p ? (parseInt(p.getAttribute('data-cantidad'), 10) || 1) : 1;
      var factor = p ? factorTotal(p) : 1;
      var base = actual.centavos || 0;
      var totalC = base * factor;
      var origC = 0;
      var texto = '';
      if (factor < q - 0.00001) {
        origC = base * q;
        texto = escalar(actual.precio, q);
      } else if (actual.centavosComparar) {
        origC = actual.centavosComparar * q;
        texto = escalar(actual.comparar, q);
      }
      hPrecio.textContent = escalar(actual.precio, factor);
      if (hOriginal) {
        hOriginal.textContent = texto;
        hOriginal.hidden = !texto;
      }
      if (hOff) {
        var pct = origC > totalC && origC > 0 ? Math.round((origC - totalC) / origC * 100) : 0;
        hOff.hidden = pct <= 0;
        if (pct > 0) hOff.textContent = pct + '% ' + (hOff.getAttribute('data-texto') || '');
      }
    }

    function pintarPaquetes() {
      if (!actual) return;
      if (!paquetes.length) pintarCabecera();
      paquetes.forEach(function (p) {
        var etiqueta = p.closest('.hero-producto__paquete');
        var q = parseInt(p.getAttribute('data-cantidad'), 10) || 1;
        var factor = factorTotal(p);
        var conDescuento = factor < q - 0.00001;
        var total = etiqueta.querySelector('[data-cp-p-total]');
        var original = etiqueta.querySelector('[data-cp-p-original]');
        var ahorro = etiqueta.querySelector('[data-cp-p-ahorro]');
        var chip = etiqueta.querySelector('[data-cp-p-porcion]');
        if (total) total.textContent = escalar(actual.precio, factor);
        if (original) {
          var texto = '';
          if (conDescuento) texto = escalar(actual.precio, q);
          else if (actual.comparar) texto = escalar(actual.comparar, q);
          original.textContent = texto;
          original.hidden = !texto;
        }
        if (ahorro) {
          ahorro.hidden = !conDescuento;
          if (conDescuento) ahorro.textContent = ahorro.getAttribute('data-prefijo') + ' ' + escalar(actual.precio, q - factor);
        }
        if (chip && datos.porciones > 0) {
          chip.textContent = escalar(actual.precio, factor / q / datos.porciones) + (datos.textoPorcion || '');
        }
        etiqueta.classList.toggle('hero-producto__paquete--activo', p.checked);
      });
      pintarCabecera();
      if (campoCantidad) campoCantidad.value = cantidad();
    }

    function pintarBoton() {
      if (!actual) return;
      if (actual.disponible) {
        boton.disabled = false;
        botonTexto.textContent = boton.getAttribute('data-texto');
        if (botonPrecio) {
          botonPrecio.hidden = false;
          botonPrecio.textContent = '· ' + escalar(actual.precio, paqueteElegido() ? factorTotal(paqueteElegido()) : 1);
        }
      } else {
        boton.disabled = true;
        botonTexto.textContent = boton.getAttribute('data-agotado');
        if (botonPrecio) botonPrecio.hidden = true;
      }
    }

    function actualizarFlechasMini() {
      if (!carrusel || !miniAnterior || !miniSiguiente) return;
      var maximo = carrusel.scrollWidth - carrusel.clientWidth;
      var hayDesborde = maximo > 2;
      miniAnterior.hidden = !hayDesborde || carrusel.scrollLeft <= 2;
      miniSiguiente.hidden = !hayDesborde || carrusel.scrollLeft >= maximo - 2;
    }

    function marcarMiniatura(i) {
      indice = i;
      miniaturas.forEach(function (m, n) {
        m.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      if (carrusel && miniaturas[i]) {
        var destino = miniaturas[i].offsetLeft - (carrusel.clientWidth - miniaturas[i].clientWidth) / 2;
        carrusel.scrollTo({ left: Math.max(0, destino), behavior: reducido() ? 'auto' : 'smooth' });
      }
      if (flechaAnterior) flechaAnterior.disabled = i <= 0;
      if (flechaSiguiente) flechaSiguiente.disabled = i >= laminas.length - 1;
    }

    function irALamina(i) {
      if (!pista || !laminas[i]) return;
      pista.scrollTo({ left: laminas[i].offsetLeft - pista.offsetLeft, behavior: reducido() ? 'auto' : 'smooth' });
      marcarMiniatura(i);
    }

    function pintarVariante() {
      if (!actual) return;
      campoId.value = actual.id;
      if (precio) precio.textContent = actual.precio;
      if (comparar) {
        comparar.hidden = !actual.comparar;
        comparar.textContent = actual.comparar || '';
      }
      if (porcion && actual.porcion) porcion.textContent = actual.porcion + (datos.textoPorcion || '');
      pintarPaquetes();
      pintarBoton();
    }

    function marcarAgotados() {
      var elegidas = [];
      grupos.forEach(function (g) {
        var r = g.querySelector('[data-cp-opcion]:checked');
        elegidas.push(r ? r.value : null);
      });
      grupos.forEach(function (g, posicion) {
        g.querySelectorAll('[data-cp-opcion]').forEach(function (r) {
          var hay = variantes.some(function (v) {
            if (!v.disponible || v.opciones[posicion] !== r.value) return false;
            return v.opciones.every(function (o, i) { return i === posicion || elegidas[i] === null || elegidas[i] === o; });
          });
          r.closest('.hero-producto__valor').classList.toggle('hero-producto__valor--agotado', !hay);
        });
      });
    }

    function alElegir() {
      var elegidas = [];
      grupos.forEach(function (g) {
        var r = g.querySelector('[data-cp-opcion]:checked');
        elegidas.push(r ? r.value : null);
      });
      var encontrada = null;
      variantes.forEach(function (v) {
        if (v.opciones.every(function (o, i) { return o === elegidas[i]; })) encontrada = v;
      });
      actual = encontrada;
      if (!actual) {
        boton.disabled = true;
        botonTexto.textContent = boton.getAttribute('data-agotado');
        if (botonPrecio) botonPrecio.hidden = true;
        marcarAgotados();
        return;
      }
      pintarVariante();
      marcarAgotados();
      if (actual.medio) {
        laminas.forEach(function (l, i) {
          if (String(l.getAttribute('data-medio')) === String(actual.medio)) irALamina(i);
        });
      }
    }

    formulario.querySelectorAll('[data-cp-opcion]').forEach(function (r) {
      r.addEventListener('change', alElegir);
    });

    var desbloqueos = seccion.querySelectorAll('[data-cp-desbloqueo]');

    function pintarDesbloqueos() {
      var unidades = 1;
      paquetes.forEach(function (p) {
        if (p.checked) unidades = parseInt(p.getAttribute('data-cantidad'), 10) || 1;
      });
      desbloqueos.forEach(function (d) {
        var minimo = parseInt(d.getAttribute('data-minimo'), 10) || 1;
        d.classList.toggle('hero-producto__desbloqueo--bloqueado', unidades < minimo);
      });
    }

    paquetes.forEach(function (p) {
      p.addEventListener('change', function () {
        pintarDesbloqueos();
        pintarPaquetes();
        pintarBoton();
      });
    });

    miniaturas.forEach(function (m) {
      m.addEventListener('click', function () {
        irALamina(parseInt(m.getAttribute('data-indice'), 10));
      });
    });

    if (flechaAnterior) flechaAnterior.addEventListener('click', function () { irALamina(Math.max(0, indice - 1)); });
    if (flechaSiguiente) flechaSiguiente.addEventListener('click', function () { irALamina(Math.min(laminas.length - 1, indice + 1)); });

    if (miniAnterior) miniAnterior.addEventListener('click', function () {
      carrusel.scrollBy({ left: -carrusel.clientWidth * 0.8, behavior: reducido() ? 'auto' : 'smooth' });
    });
    if (miniSiguiente) miniSiguiente.addEventListener('click', function () {
      carrusel.scrollBy({ left: carrusel.clientWidth * 0.8, behavior: reducido() ? 'auto' : 'smooth' });
    });
    if (carrusel) {
      carrusel.addEventListener('scroll', actualizarFlechasMini, { passive: true });
      window.addEventListener('resize', actualizarFlechasMini);
    }

    if (pista && laminas.length > 1) {
      pista.addEventListener('scroll', function () {
        if (cuadro) return;
        cuadro = window.requestAnimationFrame(function () {
          cuadro = null;
          var ancho = pista.clientWidth || 1;
          var nuevo = Math.round(pista.scrollLeft / ancho);
          if (nuevo !== indice) marcarMiniatura(nuevo);
        });
      }, { passive: true });
    }

    function mostrarMensaje(texto) {
      if (!mensaje) return;
      mensaje.textContent = texto || '';
      mensaje.hidden = !texto;
    }

    formulario.addEventListener('submit', function (evento) {
      evento.preventDefault();
      if (!actual || !actual.disponible || boton.getAttribute('aria-busy') === 'true') return;
      mostrarMensaje('');
      boton.setAttribute('aria-busy', 'true');
      var cuerpo = JSON.stringify({ items: [{ id: actual.id, quantity: cantidad() }] });
      fetch(seccion.getAttribute('data-url-agregar'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: cuerpo
      })
        .then(function (respuesta) {
          return respuesta.json().then(function (json) { return { ok: respuesta.ok, json: json }; });
        })
        .then(function (resultado) {
          boton.removeAttribute('aria-busy');
          if (!resultado.ok) {
            mostrarMensaje(resultado.json && (resultado.json.description || resultado.json.message) || 'No pudimos añadir el producto. Intenta de nuevo.');
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: resultado.json }));
          var accion = seccion.getAttribute('data-accion');
          if (accion === 'carrito') {
            window.location.href = seccion.getAttribute('data-url-carrito');
            return;
          }
          if (accion === 'abrir') {
            var selector = seccion.getAttribute('data-selector-carrito');
            var disparador = null;
            if (selector) {
              try { disparador = document.querySelector(selector); } catch (e) { disparador = null; }
            }
            if (disparador) {
              disparador.click();
            } else {
              window.location.href = seccion.getAttribute('data-url-carrito');
              return;
            }
          }
          botonTexto.textContent = boton.getAttribute('data-agregado');
          window.clearTimeout(temporizador);
          temporizador = window.setTimeout(pintarBoton, 2200);
        })
        .catch(function () {
          boton.removeAttribute('aria-busy');
          mostrarMensaje('No pudimos añadir el producto. Revisa tu conexión e intenta de nuevo.');
        });
    });

    marcarAgotados();
    pintarVariante();
    marcarMiniatura(0);
    actualizarFlechasMini();
    window.setTimeout(actualizarFlechasMini, 400);
  }

  function iniciarTodas() {
    document.querySelectorAll('[data-hero-producto]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }
  document.addEventListener('shopify:section:load', function (evento) {
    var nodo = evento.target && evento.target.querySelector ? evento.target.querySelector('[data-hero-producto]') : null;
    if (nodo) iniciar(nodo);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["porque-elegirnos1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__porQueContadores) return;
    window.__porQueContadores = true;

    var curva = function (t) {
      return t >= 1 ? 1 : 1 - Math.pow(2, -10 * t);
    };

    function analizar(texto) {
      var m = texto.match(/^(\D*?)(\d[\d.,\s]*)(\D*)$/);
      if (!m) return null;
      var crudo = m[2].replace(/\s+$/, '');
      var sepMiles = '';
      var sepDecimal = '';
      var decimales = 0;
      var limpio = crudo;
      var ultimoPunto = crudo.lastIndexOf('.');
      var ultimaComa = crudo.lastIndexOf(',');
      if (ultimoPunto > -1 && ultimaComa > -1) {
        sepDecimal = ultimoPunto > ultimaComa ? '.' : ',';
        sepMiles = sepDecimal === '.' ? ',' : '.';
      } else if (ultimoPunto > -1 || ultimaComa > -1) {
        var sep = ultimoPunto > -1 ? '.' : ',';
        var partes = crudo.split(sep);
        if (partes.length > 2 || (partes.length === 2 && partes[1].length === 3)) {
          sepMiles = sep;
        } else {
          sepDecimal = sep;
        }
      }
      if (sepMiles) limpio = limpio.split(sepMiles).join('');
      if (sepDecimal) {
        limpio = limpio.replace(sepDecimal, '.');
        decimales = limpio.split('.')[1].length;
      }
      var valor = parseFloat(limpio);
      if (isNaN(valor)) return null;
      return { prefijo: m[1], sufijo: m[3], valor: valor, decimales: decimales, sepMiles: sepMiles, sepDecimal: sepDecimal };
    }

    function formatear(datos, valor) {
      var fijo = valor.toFixed(datos.decimales);
      var partes = fijo.split('.');
      var entero = partes[0];
      if (datos.sepMiles) entero = entero.replace(/\B(?=(\d{3})+(?!\d))/g, datos.sepMiles);
      var resultado = entero;
      if (datos.decimales > 0) resultado += datos.sepDecimal + partes[1];
      return datos.prefijo + resultado + datos.sufijo;
    }

    function animar(elemento, datos, duracion) {
      var inicio = null;
      function paso(ahora) {
        if (inicio === null) inicio = ahora;
        var progreso = Math.min((ahora - inicio) / duracion, 1);
        elemento.textContent = formatear(datos, datos.valor * curva(progreso));
        if (progreso < 1) {
          window.requestAnimationFrame(paso);
        } else {
          elemento.textContent = datos.final;
        }
      }
      window.requestAnimationFrame(paso);
    }

    function iniciar(raiz) {
      if (!raiz || raiz.getAttribute('data-contar') !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      var duracion = (parseFloat(raiz.getAttribute('data-duracion')) || 2) * 1000;
      var elementos = raiz.querySelectorAll('[data-contador]');
      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          var el = entrada.target;
          observador.unobserve(el);
          animar(el, el.__porQue, duracion);
        });
      }, { threshold: 0.6 });
      elementos.forEach(function (el) {
        var final = el.textContent.trim();
        var datos = analizar(final);
        if (!datos) return;
        datos.final = final;
        el.__porQue = datos;
        el.style.minWidth = el.getBoundingClientRect().width + 'px';
        el.textContent = formatear(datos, 0);
        observador.observe(el);
      });
    }

    function iniciarTodo() {
      document.querySelectorAll('.por-que').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodo);
    } else {
      iniciarTodo();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      var raiz = evento.target && evento.target.querySelector ? evento.target.querySelector('.por-que') : null;
      iniciar(raiz);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productosenhome"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.getAttribute('data-animar') !== 'true' || !('IntersectionObserver' in window)) {
      return;
    }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var alto = window.innerHeight;
    var pendientes = [];

    raiz.querySelectorAll('.nuestros-productos__encabezado, .nuestros-productos__tarjeta').forEach(function (elemento) {
      if (elemento.getBoundingClientRect().top < alto * 0.9) {
        return;
      }
      elemento.classList.add('nuestros-productos__oculto');
      pendientes.push(elemento);
    });

    if (!pendientes.length) {
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        var orden = 0;
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) {
            return;
          }
          var elemento = entrada.target;
          elemento.style.transitionDelay = orden * 90 + 'ms';
          elemento.classList.remove('nuestros-productos__oculto');
          observador.unobserve(elemento);
          orden += 1;
          window.setTimeout(function () {
            elemento.style.transitionDelay = '';
          }, 1400);
        });
      },
      { threshold: 0.12 }
    );

    pendientes.forEach(function (elemento) {
      observador.observe(elemento);
    });
  }

  function iniciarTodas() {
    document.querySelectorAll('[data-nuestros-productos]').forEach(function (raiz) {
      if (raiz.getAttribute('data-iniciado') === 'true') {
        return;
      }
      raiz.setAttribute('data-iniciado', 'true');
      iniciar(raiz);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', iniciarTodas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quien-necesita"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(seccion) {
    if (seccion.getAttribute('data-listo') === 'si') {
      return;
    }
    seccion.setAttribute('data-listo', 'si');
    var items = seccion.querySelectorAll('[data-pq-item]');
    var laminas = seccion.querySelectorAll('[data-pq-lamina]');
    var actual = 0;
    var temporizador = null;

    function activar(indice) {
      actual = indice;
      items.forEach(function (item, i) {
        var activo = i === indice;
        item.classList.toggle('por-que-usarlo__item--activo', activo);
        var boton = item.querySelector('[data-pq-boton]');
        if (boton) {
          boton.setAttribute('aria-expanded', activo ? 'true' : 'false');
        }
      });
      laminas.forEach(function (lamina, i) {
        lamina.classList.toggle('por-que-usarlo__lamina--activa', i === indice);
      });
    }

    items.forEach(function (item, i) {
      var boton = item.querySelector('[data-pq-boton]');
      if (boton) {
        boton.addEventListener('click', function () {
          activar(i);
          detener();
        });
      }
    });

    function detener() {
      if (temporizador) {
        window.clearInterval(temporizador);
        temporizador = null;
      }
    }

    function arrancar() {
      var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (seccion.getAttribute('data-rotar') !== 'true' || reducido || items.length < 2) {
        return;
      }
      detener();
      var segundos = parseFloat(seccion.getAttribute('data-intervalo')) || 5;
      temporizador = window.setInterval(function () {
        activar((actual + 1) % items.length);
      }, segundos * 1000);
    }

    seccion.addEventListener('mouseenter', detener);
    seccion.addEventListener('mouseleave', arrancar);
    seccion.addEventListener('focusin', detener);
    arrancar();

    seccion.addEventListener('shopify:block:select', function (evento) {
      var objetivo = evento.target.closest ? evento.target.closest('[data-pq-item]') : null;
      if (objetivo) {
        activar(parseInt(objetivo.getAttribute('data-indice'), 10) || 0);
      }
      detener();
    });
  }

  function iniciarTodo(contexto) {
    (contexto || document).querySelectorAll('[data-por-que-usarlo]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodo();
    });
  } else {
    iniciarTodo();
  }
  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodo(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resultaos-anillos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (!raiz || raiz.getAttribute('data-ra-listo') === 'true') return;
    raiz.setAttribute('data-ra-listo', 'true');

    var tarjetas = raiz.querySelectorAll('[data-ra-tarjeta]');
    var animar = raiz.classList.contains('resultados-anillos--animar');
    var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!animar || reducido || !('IntersectionObserver' in window)) return;

    raiz.classList.add('resultados-anillos--preparado');
    tarjetas.forEach(function (t) {
      var n = t.querySelector('[data-ra-numero]');
      if (n) n.textContent = '0';
    });

    function contar(nodo, meta) {
      var inicio = null;
      var duracion = 1600;
      function paso(t) {
        if (inicio === null) inicio = t;
        var p = Math.min(1, (t - inicio) / duracion);
        var e = 1 - Math.pow(1 - p, 4);
        nodo.textContent = String(Math.round(meta * e));
        if (p < 1) window.requestAnimationFrame(paso);
      }
      window.requestAnimationFrame(paso);
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        var tarjeta = entrada.target;
        observador.unobserve(tarjeta);
        var n = tarjeta.querySelector('[data-ra-numero]');
        var meta = n ? parseFloat(n.getAttribute('data-valor')) || 0 : 0;
        window.setTimeout(function () {
          tarjeta.classList.add('resultados-anillos__tarjeta--visible');
          if (n) contar(n, meta);
        }, 80);
      });
    }, { threshold: 0.35 });

    tarjetas.forEach(function (t) { observador.observe(t); });
  }

  function iniciarTodas() {
    document.querySelectorAll('[data-resultados-anillos]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    var nodo = evento.target && evento.target.querySelector ? evento.target.querySelector('[data-resultados-anillos]') : null;
    if (nodo) iniciar(nodo);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tricker-nuevo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function ajustar(seccion) {
    var pista = seccion.querySelector('[data-ticker-pista]');
    var grupo = seccion.querySelector('[data-ticker-grupo]');
    if (!pista || !grupo) {
      return;
    }
    var velocidad = parseFloat(seccion.getAttribute('data-velocidad')) || 60;
    var ancho = grupo.getBoundingClientRect().width;
    if (ancho > 0) {
      pista.style.setProperty('animation-duration', (ancho / velocidad).toFixed(2) + 's', 'important');
    }
  }

  function iniciar(contexto) {
    var secciones = (contexto || document).querySelectorAll('[data-ticker-infinito]');
    secciones.forEach(function (seccion) {
      ajustar(seccion);
      if (seccion.getAttribute('data-listo') === 'si') {
        return;
      }
      seccion.setAttribute('data-listo', 'si');
      if (window.ResizeObserver) {
        var grupo = seccion.querySelector('[data-ticker-grupo]');
        if (grupo) {
          new ResizeObserver(function () {
            ajustar(seccion);
          }).observe(grupo);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciar();
    });
  } else {
    iniciar();
  }
  window.addEventListener('load', function () {
    iniciar();
  });
  document.addEventListener('shopify:section:load', function (evento) {
    iniciar(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
